export const Palette = {
	Neutral: {
		N10: "#FFFFFF",
		N20: "#FAFAFA",
		N30: "#F0F0F0",
		N40: "#DBDBDB",
		N50: "#CCCCCC",
		N60: "#999999",
		N65: "#949494",
		N70: "#A3A3A3",
		N80: "#8D8D8D",
		N90: "#737373",
		N100: "#575757",
		N110: "#454545",
		N120: "#363636",
		N130: "#2B2B2B",
		N140: "#242424",
		N150: "#161616",
	},
	Brand: {
		Brand10: "#61C1CE",
		Brand20: "#267B8A",
		Brand30: "#218A9A",
		Brand40: "#1A6F7B",
	},
	Green: {
		Green10: "#11672D",
		Green20: "#6DBC8A",
	},
	Red: {
		Red10: "#F67A91",
		Red20: "#B00020",
	},
	Yellow: {
		Yellow10: "#F5CE40",
	},
	Orange: {
		Orange10: "#FE9339",
		Orange20: "#BB5202",
	},
	Purple: {
		Purple10: "#BE95FF",
		Purple20: "#8A3FFC",
		Purple30: "#474FAA",
	},
	Avatar: {
		Red: "#BB2E02",
		Orange: "#BB5202",
		Purple: "#8B02BB",
		Blue: "#037CB0",
		Green: "#0C8043",
		Teal: "#007C84",
		Gold: "#887615",
		Pink: "#B24545",
		DarkGrey: "#545454",
		LightGrey: "#DBDBDB",
		Mint: "#12865C",
		Honey: "#CFAF2D",
	},
	Tag: {
		Orange: "#BB5202",
		Purple: "#8B02BB",
		Mint: "#12865C",
		Teal: "#007C84",
	},
};
